import ExecAPI from 'appRoot/api/api';

export function ScaleImage(imageData)
{
	return ExecAPI("ImageScaler/ScaleImage", { imageData });
}